export const DEFAULT_CONFLICT_MINS = 90;
export const MAX_CHAIRS = 8
export const MAX_CHAIRS_LEGACY = 20
